export const RESPSE = {
  3: "3", //NO CUMPLE
  4: "4", //CUMPLE
};
